'use es6';

import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import { fetchSettingsRequest, fetchSettingsResponse } from 'FormsUI/actions/leadinSettings';
const requested = handleActions({
  [fetchSettingsRequest]: () => {
    return true;
  },
  [fetchSettingsResponse]: () => {
    return false;
  }
}, false);
const value = handleActions({
  [fetchSettingsResponse]: (__, {
    payload
  }) => payload
}, {});
const error = handleActions({
  [fetchSettingsRequest]: () => {
    return false;
  },
  [fetchSettingsResponse]: {
    next() {
      return false;
    },
    throw() {
      return true;
    }
  }
}, false);
export default combineReducers({
  requested,
  value,
  error
});